import {AfterViewInit, Component, ViewContainerRef} from '@angular/core';
import {InjectionsService} from './injections.service';

@Component({
    selector: 'vui-injections',
    templateUrl: './injections.component.html',
    styleUrls: ['./injections.component.scss']
})
export class InjectionsComponent implements AfterViewInit {
    constructor(private injectionsService: InjectionsService,
                public viewContainerRef: ViewContainerRef) {
    }

    ngAfterViewInit() {
        this.injectionsService.post(this.viewContainerRef);
    }
}
